import React, { useState } from "react";
import ProstateMain from "../components/ProstateMain";
import ProstateForm from "../components/ProstateMain/ProstateForm";

const Prostate = () => {
  const [sopen, setSopen] = useState(false);
  const handleClose = () => {
    setSopen(true);
  };
  return (
    <>{sopen ? <ProstateMain /> : <ProstateForm onFormClose={handleClose} />}</>
  );
};

export default Prostate;
